import { render, staticRenderFns } from "./VectorLegend.vue?vue&type=template&id=3bfbbea4&scoped=true"
import script from "./VectorLegend.vue?vue&type=script&lang=ts"
export * from "./VectorLegend.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./VectorLegend.vue?vue&type=style&index=0&id=3bfbbea4&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3bfbbea4",
  null
  ,true
)

export default component.exports